export const ADMIN_TOKEN = 'huafasjkfnj$kaDLd@JNAldsfnjrnw4dAD$';
